import React from 'react';
import { colors } from '@web-for-marketing/react-ui';

interface StatusDotsProps {
    steps: {
        status: 'completed' | 'active' | 'pending';
    }[];
}

const classes = {
    dotContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dots: {
        marginRight: '1.6rem',
    },
} as const;

export function StatusDots({ steps }: StatusDotsProps): React.ReactElement {
    return (
        <div css={classes.dotContainer}>
            {steps.map((step, index) => {
                return step.status === 'active' ? (
                    <svg
                        key={index}
                        xmlns='http://www.w3.org/2000/svg'
                        css={classes.dots}
                        width='18'
                        height='18'
                        viewBox='0 0 18 18'
                        fill='none'
                    >
                        <circle cx='9' cy='9' r='4' fill='#00AEFF' />
                        <circle
                            cx='9'
                            cy='9'
                            r='6.5'
                            stroke={colors.core.curveLogic}
                            strokeOpacity='0.2'
                            strokeWidth='5'
                        />
                    </svg>
                ) : (
                    <svg
                        key={index}
                        css={classes.dots}
                        xmlns='http://www.w3.org/2000/svg'
                        width='8'
                        height='8'
                        viewBox='0 0 8 8'
                        fill='none'
                    >
                        <circle
                            cx='4'
                            cy='4'
                            r='4'
                            fill={step.status === 'completed' ? colors.action.curveLogic : colors.action.paleGray}
                        />
                    </svg>
                );
            })}
        </div>
    );
}
